<script>
import { ValidationObserver } from 'vee-validate'
export default {
  components: { ValidationObserver },
  data() {
    return {
      forgotButton: false,

      updateForgot: null,
      email: null,
      validationMessage: null,
      showError: false,
    }
  },
  methods: {
    sendForgotPassword() {
      //  console.log(data)
      this.forgotButton = true
      this.$refs.forgot.validate().then((success) => {
        if (success) {
          this.forgotButton = true
          const requestPayload = {
            email: this.useremail,

            _jv: {
              type: 'auth',
            },
          }
          var parent = this
          this.$store
            .dispatch('jv/post', [
              requestPayload,
              { url: '/auth/password/forgot' },
            ])
            .then((response) => {
              this.forgotButton = false

              // services.decodeJWT(response.token)
              this.showError = false
              this.$bvToast.show('forgotPassword')

              var id = Object.keys(response)

              this.validationMessage = response[id[0]]._jv.detail
              setTimeout(() => {
                parent.$bvToast.hide('forgotPassword')
                parent.validationMessage = null
              }, 5000)
            })
            .catch((error) => {
              this.forgotButton = false
              this.showError = true
              if (error.response) {
                for (let err of error.response.data.errors) {
                  this.$bvToast.show('forgotPassword')
                  this.validationMessage = err.detail
                }
                setTimeout(() => {
                  parent.$bvToast.hide('forgotPassword')
                  parent.validationMessage = null
                }, 5000)
              } else {
                this.$bvToast.show('forgotPassword')
                this.validationMessage = 'Please check your network connection'
                setTimeout(() => {
                  parent.$bvToast.hide('forgotPassword')

                  parent.validationMessage = null
                }, 5000)
              }
            })
        } else this.forgotButton = false
      })
    },
  },
}
</script>
<template
  ><div>
    <section :class="$style.loginSection">
      <b-container fluid>
        <b-container>
          <b-row
            :class="[$style.rowAlign]"
            class="align-items-center justify-content-center"
          >
            <b-col cols="12" md="10" lg="8" :class="$style.userLoginWraper">
              <b-row>
                <div class="FL w35 w100-sm" :class="$style.loginLeft">
                  <div :class="$style.contextWraper">
                    <div :class="[$style.contentWrap, $style.tc, $style.mt20]">
                      <img
                        src="@assets/images/logoD-white.png"
                        alt="Application Logo"
                      />
                    </div>
                    <div :class="$style.contextImage">
                      <img
                        src="@assets/images/loginBg.png"
                        alt="Content Image"
                      />
                      <span></span>
                    </div>
                    <div :class="$style.contentSlider">
                      <p
                        >Committed to giving every child and young person the
                        future they deserve.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="FL w65 w100-sm" :class="$style.loginLeft">
                  <div :class="$style.loginWraper">
                    <div :class="$style.logoWraper" class="w60 w100-sm FR">
                      <img
                        src="@assets/images/logoD.png"
                        alt="Application Logo"
                      />
                      <h5 class="mt20 mb0-sm">Forgotten Your Password..?</h5>
                    </div>
                    <div class="clear"></div>
                    <ValidationObserver ref="forgot">
                      <form
                        :class="$style.form"
                        @submit.prevent="sendForgotPassword"
                      >
                        <CommonBaseInputText
                          id="email"
                          type="text"
                          name="email"
                          form="forgot"
                          :value="email"
                          label="Email"
                          :validation="{ required: true, email: true }"
                          @update="useremail = $event"
                        />

                        <a
                          href="javascript:void(0)"
                          class="w60 w100-sm tc-sm FR mt10"
                          :class="$style.linkText"
                          @click="$emit('login', true)"
                          >Back to Sign In</a
                        >
                        <div
                          :class="[$style.buttonWrapper]"
                          class="w60 w100-sm tc-sm FR mt30"
                        >
                          <button
                            type="submit"
                            class="buttonCommon buttonPrimary button"
                          >
                            <b-spinner
                              v-if="forgotButton"
                              style="width: 18px; height: 18px;"
                              class="ml15 mr15"
                              label="Spinning"
                            ></b-spinner>
                            {{ !forgotButton ? 'Send' : '' }}
                          </button>
                        </div>
                      </form>
                    </ValidationObserver>
                    <div class="clear"></div>
                  </div>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </section>
    <!-- toaster -->
    <div :class="$style.toasterMainWrap">
      <b-toast id="forgotPassword" solid no-auto-hide>
        <div
          class="d-flex"
          :class="
            showError
              ? [$style.loginToasterWraper, $style.error]
              : [$style.loginToasterWraper, $style.success]
          "
        >
          <div :class="$style.toasterLeft">
            <BIcon
              icon="chat-square-dots-fill"
              :class="$style.toasterIcon"
            ></BIcon>
          </div>
          <div :class="$style.toasterRight">
            <strong class="mr-auto" :class="$style.toasterHeader"
              >Notice!</strong
            >
            <p :class="$style.toasterContent">{{ validationMessage }}</p>
          </div>
          <div class="clear"></div>
        </div>
      </b-toast>
    </div>
    <!-- toaster -->
  </div>
</template>
<style lang="scss" module>
@import '@design';

.linkText {
  font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 17px;
  color: #007bff;
}

.loginSection {
  position: relative;
  z-index: 99;
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  background-image: url('~@assets/images/login-bg.png');
  background-repeat: repeat;
}

.rowAlign {
  z-index: 99;
  min-height: 100vh;
}

.contextWraper {
  position: relative;
  height: 100%;
  padding: 30px;
  background: #f15d22;
}

.loginWraper {
  z-index: 99;
  padding: 50px;
}

.contextImage {
  margin: 30px 0;

  img {
    width: 100%;
    max-width: 554px;
  }
}

.contentWrap {
  img {
    width: 110px;
    margin: 0 auto;
  }
}

.contentSlider {
  p {
    margin: 10px 0;
    font-family: 'SourceSansProLight', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 17px;
    line-height: 20px;
    color: #fff;
    text-align: center;
  }
}

.userLoginWraper {
  width: 100%;
  margin: 20px 0;
  overflow: hidden;
  background: #fff;
  border: 1px solid #ecebeb;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

  h5 {
    font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    color: $primary-color;
  }
}

.logoWraper {
  img {
    width: 100px;
    height: auto;
    margin-top: 10px;
  }
}

@media only screen and (max-width: 767px) {
  .contextWraper {
    display: none;
  }

  .loginWraper {
    padding: 30px;
  }

  .logoWraper img {
    width: 80px;
  }

  .userLoginWraper h5 {
    font-size: 22px;
  }
}
</style>
